export const statTitle = {
  fontWeight: 700,
  fontSize: 48,
  lineHeight: "3.75rem",
  marginBottom: "1.25rem",
};

export const statContent = {
  fontWeight: 700,
  fontSize: 18,
  lineHeight: "1.75rem",
  marginBottom: "1.25rem",
};
